import {
  ASSESSOR_FUNCTION,
  CHANGE_CATEGORY,
  CHANGE_STATUS,
  CHANGE_TYPE,
  CREATION_METHOD,
  CRITICALITY,
  SAFETY_CONCERN,
  SCOPE_TYPE,
  SOURCE_TYPE,
  TAssessorFunction,
  TChangeCategory,
  TChangeStatus,
  TChangeType,
  TCreationMethod,
  TCriticality,
  TSafetyConcern,
  TScopeType,
  TSourceType,
  TUrgency,
  URGENCY,
} from './models';

// Fixed "today" for the prototype so relative dates are stable across sessions.
export const CHANGE_V2_CURRENT_DATE = new Date('2026-07-15T00:00:00.000Z');

// Human-readable id format assigned on request submission: CHG-2026-####.
export const CHANGE_V2_ID_PREFIX = 'CHG';

// Human-readable request id available before a Change ID is assigned.
export const CHANGE_V2_REQUEST_ID_PREFIX = 'REQ';

// Ordered option lists, all derived from the stable enums.
export const CHANGE_STATUS_OPTIONS: TChangeStatus[] = Object.values(CHANGE_STATUS);
export const CHANGE_CATEGORY_OPTIONS: TChangeCategory[] = Object.values(CHANGE_CATEGORY);
export const CHANGE_TYPE_OPTIONS: TChangeType[] = Object.values(CHANGE_TYPE);
export const SCOPE_TYPE_OPTIONS: TScopeType[] = Object.values(SCOPE_TYPE);
export const CRITICALITY_OPTIONS: TCriticality[] = Object.values(CRITICALITY);
export const URGENCY_OPTIONS: TUrgency[] = Object.values(URGENCY);
export const SAFETY_CONCERN_OPTIONS: TSafetyConcern[] = Object.values(SAFETY_CONCERN);
export const SOURCE_TYPE_OPTIONS: TSourceType[] = Object.values(SOURCE_TYPE);
export const ASSESSOR_FUNCTION_OPTIONS: TAssessorFunction[] = Object.values(ASSESSOR_FUNCTION);
export const CREATION_METHOD_OPTIONS: TCreationMethod[] = Object.values(CREATION_METHOD);

// Saved-view options for the dashboard (mock only, purely a filter preset label).
export const SAVED_VIEW = {
  ALL: 'All changes',
  MY_ACTIVE: 'My active changes',
  NEEDS_ATTENTION: 'Needs attention',
  AWAITING_EXTERNAL: 'Awaiting external decision',
} as const;
export type TSavedView = (typeof SAVED_VIEW)[keyof typeof SAVED_VIEW];
export const SAVED_VIEW_OPTIONS: TSavedView[] = Object.values(SAVED_VIEW);

// Prototype-only demo states, surfaced through the workspace state switcher.
export const PROTOTYPE_STATE = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  RETURNED: 'Returned',
  READ_ONLY: 'Read-only',
  SAVE_FAILED: 'Save failed',
  PERMISSION_DENIED: 'Permission denied',
  CANCELLED: 'Cancelled',
} as const;
export type TPrototypeState = (typeof PROTOTYPE_STATE)[keyof typeof PROTOTYPE_STATE];
export const PROTOTYPE_STATE_OPTIONS: TPrototypeState[] = Object.values(PROTOTYPE_STATE);

// Autosave lifecycle shown in the workspace footer.
export const AUTOSAVE_STATUS = {
  SAVED: 'Saved',
  SAVING: 'Saving',
  UNSAVED: 'Unsaved changes',
  FAILED: 'Save failed',
} as const;
export type TAutosaveStatus = (typeof AUTOSAVE_STATUS)[keyof typeof AUTOSAVE_STATUS];

// QMS areas offered as selection options (reference data, not per-change data).
export const QMS_AREA_OPTIONS: string[] = [
  'Design and development',
  'Risk management',
  'Document control',
  'Supplier management',
  'Production and process controls',
  'Labeling and IFU',
  'Post-market surveillance',
  'Complaint handling',
  'CAPA',
  'Training',
  'Software lifecycle',
  'Clinical evaluation',
];
